<template>
  <div>
    <button
      class="tw-bg-inherit tw-border-none tw-cursor-pointer tw-text-gray-400 hover:tw-text-gray-700"
      title="Meeting Preferences"
      @click="show = true"
    >
      <i class="fa fa-cog tw-text-2xl" />
    </button>

    <StakeModal
      v-model="show"
      window-classes=""
    >
      <MeetingBotSettings />
    </StakeModal>
  </div>
</template>


<script>
import StakeModal from '@stakeui/StakeModal.vue';
import MeetingBotSettings from './MeetingBotSettings.vue';

export default {
  name: 'MeetingBotSettingsButton',
  components: {
    StakeModal,
    MeetingBotSettings,
  },
  props: [/* Inputs */],
  data() {
    return {
      show: false,
    };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {},
};
</script>


<style scoped>

</style>
